import { RefObject } from 'react';
import { useElementMeasures } from '../../useElementMeasures';

export const useSchedulerMaxHeight = (containerRef?: RefObject<HTMLElement | null>) => {
  const headerHeight = useElementMeasures('dialog-header', undefined, containerRef).height;
  const footerHeight = useElementMeasures('dialog-footer', undefined, containerRef).height;
  const overlayHeight = useElementMeasures('dialog-overlay').height;
  const padding = 112;

  return overlayHeight - headerHeight - footerHeight - padding;
};
